import { haversineM } from "./projection.js";
const DEG2RAD = Math.PI / 180;
const RAD2DEG = 180 / Math.PI;
/** Initialer Großkreis-Kurs von `from` nach `to` in Grad, 0°=Nord, im Uhrzeigersinn. */
export function edgeBearingDeg(from, to) {
    const phi1 = from.latitude * DEG2RAD;
    const phi2 = to.latitude * DEG2RAD;
    const dLambda = (to.longitude - from.longitude) * DEG2RAD;
    const y = Math.sin(dLambda) * Math.cos(phi2);
    const x = Math.cos(phi1) * Math.sin(phi2) -
        Math.sin(phi1) * Math.cos(phi2) * Math.cos(dLambda);
    const theta = Math.atan2(y, x) * RAD2DEG;
    return (theta + 360) % 360;
}
/**
 * Längste Kante des geschlossenen Polygons (First-/Traufe-Kandidat zur
 * Rasterorientierung). < 2 Punkte → null.
 */
export function longestEdge(vertices) {
    const n = vertices.length;
    if (n < 2)
        return null;
    let best = null;
    for (let i = 0; i < n; i++) {
        const a = vertices[i];
        const b = vertices[(i + 1) % n];
        const lengthM = haversineM(a, b);
        if (best === null || lengthM > best.lengthM) {
            best = { a, b, lengthM, bearingDeg: edgeBearingDeg(a, b) };
        }
    }
    return best;
}
/**
 * Dach-Azimut (Kompassrichtung der Falllinie) senkrecht zur Traufe A→B.
 * @param downslopeHint optionaler Punkt auf der abfallenden Seite; ohne ihn gilt
 *   die Konvention "Falllinie rechts von A→B" (= Bearing + 90°).
 */
export function roofAzimuthFromEave(eaveA, eaveB, downslopeHint) {
    const eave = edgeBearingDeg(eaveA, eaveB);
    const candRight = (eave + 90) % 360;
    if (!downslopeHint)
        return candRight;
    const candLeft = (eave + 270) % 360;
    const mid = {
        latitude: (eaveA.latitude + eaveB.latitude) / 2,
        longitude: (eaveA.longitude + eaveB.longitude) / 2,
    };
    const toHint = edgeBearingDeg(mid, downslopeHint);
    return angularDistanceDeg(toHint, candRight) <= angularDistanceDeg(toHint, candLeft)
        ? candRight
        : candLeft;
}
/** Kleinster Winkelabstand zweier Kurse in Grad, [0, 180]. */
function angularDistanceDeg(a, b) {
    return Math.abs(((a - b + 540) % 360) - 180);
}
//# sourceMappingURL=bearing.js.map